import React, {useRef, useState} from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Switch from '@material-ui/core/Checkbox'
import Title from './Title'
import Utils from "EurestoFonction/Utils";

export default React.memo(props => {
    const value = useRef(props.checked === true || props.checked === 'true' || props.checked === '1' || props.checked === 1 || false)
    const [key, setKey] = useState(Utils.uuidv4())

    const onChange = (e) => {
        value.current = e.target.checked
        setKey(Utils.uuidv4())
        props.onChange(e.target.checked, props.name)
    }

    return (
        props.title !== undefined && props.title !== '' && <Title inline={props.inline} title={props.title} alignContent={'flex-start'} justify={'flex-start'}>
            <Switch
                disableRipple
                checked={value.current}
                onChange={props.disabled !== true && onChange}
                color={'default'}
            />
        </Title>
        ||
        <FormControlLabel style={{padding: 7.5}}
                          label={props.label}
                          control={
                              <Switch
                                  disableRipple
                                  checked={value.current}
                                  onChange={props.disabled !== true && onChange}
                                  color={'default'}
                              />
                          }
        />
    )
})



// WEBPACK FOOTER //
// ./app/Components/Switch.js